import { render, staticRenderFns } from "./VisitEdit.vue?vue&type=template&id=5f48c05e"
import script from "./VisitEdit.vue?vue&type=script&lang=js"
export * from "./VisitEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports